import {
  BaseCalculationItemType,
  FairleadType,
  MooringPointType
} from '@/domain/type/calculationItem.type.ts'

class Vector3D {
  public x: number
  public y: number
  public z: number

  constructor(x: number, y: number, z: number) {
    this.x = x
    this.y = y
    this.z = z
  }

  dot(other: Vector3D): number {
    return this.x * other.x + this.y * other.y + this.z * other.z
  }

  length(): number {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z)
  }
}

const angleInDegreesHorizontal = (
  item1: BaseCalculationItemType,
  item2: BaseCalculationItemType
): number => {
  let angle = angleInDegrees(item1.x, item2.x, item1.y, item2.y)
  angle = Math.abs(angle - 90)
  angle = Math.round(angle * 100) / 100
  return angle
}

const angleInDegrees = (x1: number, x2: number, y1: number, y2: number): number => {
  return (Math.atan2(y2 - y1, x2 - x1) * 180) / Math.PI
}

const angleInDegreesVertical = (mooringPoint: MooringPointType, fairlead: FairleadType): number => {
  const x1 = mooringPoint.x,
    y1 = mooringPoint.y,
    z1 = mooringPoint.z
  const x2 = fairlead.x,
    y2 = fairlead.y,
    z2 = fairlead.calculated_z
  const vector = new Vector3D(x2 - x1, y2 - y1, z2 - z1)
  const dot = vector.dot(new Vector3D(0, 0, 1))
  let angle = (Math.acos(dot / vector.length()) * 180) / Math.PI
  angle = Math.abs(angle - 90)
  angle = Math.round(angle * 100) / 100
  return angle
}

const horizontalAngleFairlead = (
  mooringPoint: MooringPointType,
  fairlead: FairleadType
): number => {
  if (!mooringPoint) {
    return NaN
  }
  let angle = angleInDegreesHorizontal(mooringPoint, fairlead)
  if (fairlead.line_type === 'Spring') {
    angle = angle - 90
  }
  angle = Math.abs(angle)
  angle = Math.round(angle * 100) / 100
  return angle
}

export { angleInDegreesHorizontal, angleInDegreesVertical, horizontalAngleFairlead }
